import { useEffect, useState } from "react";
import api from "@/lib/api";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell,
} from "recharts";
import Money from "@/components/Money";
import { useCurrency } from "@/lib/currency";

export default function VendorRevenueChart() {
  const [data, setData] = useState([]);
  const { format } = useCurrency();

  useEffect(() => {
    let cancelled = false;
    api.get("/vendor/revenue-monthly")
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch((e) => { console.error("revenue monthly load failed:", e); });
    return () => { cancelled = true; };
  }, []);

  const total = data.reduce((s, d) => s + (d.revenue || 0), 0);
  const max = Math.max(0, ...data.map((d) => d.revenue || 0));

  return (
    <div className="rounded-2xl border border-border p-6 bg-white" data-testid="vendor-revenue-chart">
      <div className="flex items-end justify-between flex-wrap gap-2 mb-4">
        <div>
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">Last 12 months</div>
          <h3 className="font-display text-2xl font-medium mt-1">Monthly revenue</h3>
        </div>
        <div className="text-right">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">Total</div>
          <div className="font-display text-2xl font-semibold"><Money amount={total} /></div>
        </div>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#6b7280" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#6b7280" }} axisLine={false} tickLine={false} width={56} tickFormatter={(v) => format(v)} />
            <Tooltip
              cursor={{ fill: "rgba(37, 99, 235, 0.06)" }}
              contentStyle={{ borderRadius: 12, border: "1px solid #e5e7eb", fontSize: 12 }}
              formatter={(value, _name, ctx) => [format(value), `Revenue (${ctx.payload.bookings} bookings)`]}
            />
            <Bar dataKey="revenue" radius={[8, 8, 0, 0]}>
              {data.map((d) => (
                <Cell key={d.label} fill={d.revenue === max && max > 0 ? "#2563eb" : "#dbeafe"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
